import * as constants from './constants';
import http from '../../../utils/request';

const handleDetailsData = (result) => ({
  type: constants.GET_DETAILS_DATA,
  details: result
});

export const fetchDetailsData =  (type, obj) => {
  return (dispatch) => {
    http('post', type === 1 ? '/achieve/detail/index' : '/achieve/demand', obj).then((res) => {
      if (res.code === 200) {
        const result = res.data;
        // console.log('result', result);
        dispatch(handleDetailsData(result));
      }
    });
  }
}